'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typingMessageReceived = undefined;

var _isFromBot = require('conversations-schema/pubnub-message/operators/isFromBot');

var _agentTypingMessageReceived = require('./agentTypingMessageReceived');

var _botTypingMessageReceived = require('./botTypingMessageReceived');

var typingMessageReceived = exports.typingMessageReceived = function typingMessageReceived(message) {
  return function (dispatch) {
    if ((0, _isFromBot.isFromBot)(message)) {
      dispatch((0, _botTypingMessageReceived.botTypingMessageReceived)(message));
    } else {
      dispatch((0, _agentTypingMessageReceived.agentTypingMessageReceived)(message));
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./js/typing-indicators/actions/typingMessageReceived.js
// module id = 418
// module chunks = 2 3